module.exports = __webpack_public_path__ + "static/media/x.7ec28fae.svg";